import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { profiles } from '../data/testimonials';
import { OFFER_ANCHOR } from '../data/constants';
export function Testimonials() {
  return <section className="bg-white py-5 sm:py-7" data-id="element-187" data-mp="3fz5pc1f45qid">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-188" data-mp="3fxuly2pkykrs">
        <h2 className="text-center text-2xl leading-tight text-navy sm:text-4xl" data-id="element-189" data-mp="3b1487m19019j">
          POUR QUI EST <span className="text-tech" data-id="element-190" data-mp="36zinxfmdwkpb">CET ATLAS ?</span>
        </h2>

        <div className="mt-3 grid gap-2 md:grid-cols-2 md:gap-2.5" data-id="element-191" data-mp="36wmplq6mju0c">
          {profiles.map((profile, i) => <a key={profile.who} href={OFFER_ANCHOR} className={`flex flex-col rounded-xl border border-metal bg-ice p-3 shadow-sm transition-colors duration-150 ease-out hover:border-tech sm:p-4 ${i === 0 ? 'border-l-4 border-l-tech md:col-span-2' : ''}`} data-id="element-192" data-mp="2x0tbw3h65ugz" data-mpi={i}>
              <h3 className="font-display text-sm font-extrabold leading-tight text-navy sm:text-base" data-id="element-193" data-mp="qbn52xkxleqg">
                <span aria-hidden="true" data-id="element-194" data-mp="h4dckkmqpm3n">{profile.icon}</span> {profile.who}
              </h3>
              <p className="mt-1 text-sm leading-snug text-steel" data-id="element-195" data-mp="m5sx8bl09qli">{profile.situation}</p>
              <p className="mt-1.5 flex items-start gap-1.5 text-sm font-medium leading-snug text-navy" data-id="element-196" data-mp="78ttwzx6sjwu">
                <CheckCircle2Icon className="mt-0.5 h-4 w-4 shrink-0 text-teal" aria-hidden="true" data-id="element-197" data-mp="c7mwvyeuksir" />
                {profile.benefit}
              </p>
            </a>)}
        </div>
      </div>
    </section>;
}